import {
  AboutSection,
  ContactSection,
  FeaturedSection,
  HeaderSection,
  StrengthSection,
} from "./components";
import styles from "./styles.module.scss";

const Home = () => {
  return (
    <div className={styles.homeContainer}>
      <HeaderSection />
      <StrengthSection />
      <FeaturedSection />
      <AboutSection />
      <ContactSection />
    </div>
  );
};

export default Home;
